import { ManuteRequestConfig } from '@/api/types';
import { ProposalQueryParams } from '@/api/requests/proposal/types';
import { ProposalRequest } from '@/store/modules/proposal/types';

/**
 * Request to find all proposals.
 * @param params
 */
export const ALL = (params?: ProposalQueryParams): ManuteRequestConfig => ({
    method: 'GET',
    url: '/proposals',
    params: {
        page_size: 50,
        ...params,
    },
});

/**
 * Request to save a new proposal.
 * @param data
 */
export const STORE = (data: ProposalRequest): ManuteRequestConfig => ({
    method: 'POST',
    url: '/proposals',
    data,
});

/**
 * Request to find a proposal by id.
 * @param proposalId
 */
export const FIND = (proposalId: number): ManuteRequestConfig => ({
    method: 'GET',
    url: `/proposals/${proposalId}`,
});

/**
 * Request to update an existing proposal.
 * @param proposalId
 * @param data
 */
export const UPDATE = (proposalId: number, data: ProposalRequest): ManuteRequestConfig => ({
    method: 'PUT',
    url: `/proposals/${proposalId}`,
    data,
});

/**
 * Request to send the proposal to the assigned customer
 * @param proposalId
 * @param data
 */
export const SEND_TO_ASSIGNED_CUSTOMER = (proposalId: number, data: ProposalRequest): ManuteRequestConfig => ({
    method: 'POST',
    url: `/proposals/${proposalId}/send-to-assigned-customer`,
    data,
});

/**
 * Request to send the proposal to the assigned customer
 * @param proposalId
 * @param data
 */
export const SEND_TO_CHOSEN_ADDRESSES = (proposalId: number, mailAddresses: Array<{email: String, sendType: String}>, addressee: String): ManuteRequestConfig => ({
    method: 'POST',
    url: `/proposals/${proposalId}/send-to-chosen-addresses`,
    data: {
        addressee: addressee,
        mail_addresses: mailAddresses.map((mailAddress: {email: String, sendType: String}) => {
            return {
                email: mailAddress.email,
                send_type: mailAddress.sendType,
            }
        })
    },
});

/**
 * Download the proposal as pdf
 * @param proposalId
 * @param data
 */
export const DOWNLOAD_PROPOSAL_AS_PDF = (proposalId: number, params?: ProposalQueryParams): ManuteRequestConfig => ({
    method: 'GET',
    url: `/proposals/${proposalId}/download-proposal-as-pdf`,
    params: {
        addressee: params?.addressee
    },
    responseType: 'blob'
});

/**
 * Download the proposal as pdf
 * @param proposalId
 * @param data
 */
export const GET_PROPOSAL_PDF_AS_LINK = (proposalId: number, params?: ProposalQueryParams): ManuteRequestConfig => ({
    method: 'GET',
    url: `/proposals/${proposalId}/proposal-pdf-as-link`,
    params: {
        addressee: params?.addressee
    }
});